import { twApi } from '../api';

const qbDesktopApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getQbDesktopConfig: builder.query<
      {
        config?: any;
        connectionChecks: { divisionId: string; isConnected: boolean; errorMessage?: string }[];
      },
      { divisionId: string | undefined }
    >({
      query: ({ divisionId }) => ({
        url: `/qb-desktop/config/${divisionId ? `${divisionId}` : ''}`,
        method: 'GET'
      }),
      providesTags: () => [{ type: 'QbDesktop', id: 'QB_DESKTOP_CONFIG' }]
    }),
    getQbDesktopIsSyncing: builder.query<boolean, undefined>({
      query: () => ({
        url: '/qb-desktop/is-syncing',
        method: 'GET'
      }),
      providesTags: () => [{ type: 'QbDesktop', id: 'QB_DESKTOP_IS_SYNCING' }]
    })
  })
});

export const {
  useGetQbDesktopConfigQuery,
  useGetQbDesktopIsSyncingQuery
} = qbDesktopApi;
